import { render, staticRenderFns } from "./CountCompete.vue?vue&type=template&id=3ed8f0e2&scoped=true&"
import script from "./CountCompete.vue?vue&type=script&lang=js&"
export * from "./CountCompete.vue?vue&type=script&lang=js&"
import style0 from "./CountCompete.vue?vue&type=style&index=0&id=3ed8f0e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed8f0e2",
  null
  
)

export default component.exports